<div class="vc-tasks-real vc-view-shell">
  <p-toast></p-toast>
  <p-confirmDialog></p-confirmDialog>
  <main class="vc-tasks-real__content vc-view-content">

  <!-- Alerta de tareas próximas a vencer -->
  @if (showDueSoonAlert && dueSoonTasks.length > 0) {
    <div class="due-soon-alert">
      <div class="due-soon-alert__content">
        <div class="due-soon-alert__icon">
          <i class="fas fa-clock"></i>
        </div>
        <div class="due-soon-alert__text">
          <strong>{{ 'TASKS.UI.DUE_SOON.TITLE' | translate }}</strong>
          {{ 'TASKS.UI.DUE_SOON.INTRO' | translate }}
          <span class="due-soon-alert__count">{{ dueSoonTasks.length }}</span>
          {{ 'TASKS.UI.DUE_SOON.TEXT' | translate }}
        </div>
        <div class="due-soon-alert__tasks">
          @for (task of dueSoonTasks.slice(0, 3); track task.id) {
            <span class="due-soon-alert__task" (click)="viewTask(task)">
              {{ task.task_key }}: {{ task.title | slice:0:30 }}{{ task.title.length > 30 ? '...' : '' }}
            </span>
          }
          @if (dueSoonTasks.length > 3) {
            <span class="due-soon-alert__more">
              {{ 'TASKS.UI.DUE_SOON.MORE' | translate:{ count: (dueSoonTasks.length - 3) } }}
            </span>
          }
        </div>
      </div>
      <button
        pButton
        type="button"
        icon="fas fa-times"
        class="p-button-text p-button-sm due-soon-alert__close"
        (click)="closeDueSoonAlert()"
      ></button>
    </div>
  }

  <!-- Loading -->
  @if (loading) {
    <div class="vc-tasks-real__loading">
      <p-progressSpinner></p-progressSpinner>
      <p>{{ 'TASKS.UI.LOADING' | translate }}</p>
    </div>
  }

  <!-- Content -->
  @if (!loading) {
    <!-- Contenido principal -->
    <div class="tasks-content vc-surface-panel vc-surface-panel--padded">
      <!-- Barra de filtros -->
      <div class="filters-bar">
        <div class="filters-bar__top">
          <!-- Búsqueda global -->
          <div class="filters-bar__search">
            <p-iconField iconPosition="left">
              <p-inputIcon styleClass="fas fa-search"></p-inputIcon>
              <input
                pInputText
                type="text"
                [(ngModel)]="globalFilter"
                placeholder="{{ 'TASKS.UI.FILTERS.SEARCH_PLACEHOLDER' | translate }}"
                (input)="onGlobalFilter($event)"
                class="filters-bar__search-input"
              />
            </p-iconField>
          </div>

          <!-- Filtro rápido -->
          <div class="filters-bar__quick">
            <p-dropdown
              [options]="quickFilterOptions"
              [(ngModel)]="selectedQuickFilter"
              optionLabel="label"
              optionValue="value"
              placeholder="{{ 'TASKS.UI.FILTERS.QUICK_PLACEHOLDER' | translate }}"
              (onChange)="onQuickFilterChange()"
              styleClass="filters-bar__quick-dropdown"
            ></p-dropdown>
          </div>

          <!-- Ordenamiento -->
          <div class="filters-bar__sort">
            <p-dropdown
              [options]="sortOptions"
              [(ngModel)]="selectedSort"
              optionLabel="label"
              optionValue="value"
              placeholder="{{ 'TASKS.UI.SORT.PLACEHOLDER' | translate }}"
              (onChange)="onSortChange()"
              styleClass="filters-bar__sort-dropdown"
            ></p-dropdown>
          </div>

          <!-- Botones de acción -->
          <div class="filters-bar__actions">
            <button
              *ngIf="canCreateTasks"
              pButton
              type="button"
              [label]="'TASKS.UI.HEADER.CREATE' | translate"
              icon="fas fa-plus"
              class="p-button-primary p-button-sm"
              (click)="openCreateView()"
            ></button>
            <button
              pButton
              type="button"
              [icon]="showStats ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"
              [label]="showStats ? ('TASKS.UI.STATS.HIDE' | translate) : ('TASKS.UI.STATS.SHOW' | translate)"
              class="p-button-text p-button-sm vc-tasks-real__stats-toggle"
              (click)="toggleStats()"
            ></button>
            <button
              pButton
              type="button"
              [label]="showAdvancedFilters ? ('TASKS.UI.FILTERS.HIDE' | translate) : ('TASKS.UI.FILTERS.SHOW' | translate)"
              [icon]="showAdvancedFilters ? 'fas fa-chevron-up' : 'fas fa-filter'"
              class="p-button-outlined p-button-secondary p-button-sm"
              (click)="toggleAdvancedFilters()"
            ></button>
            <button
              *ngIf="hasActiveFilters()"
              pButton
              type="button"
              icon="fas fa-times"
              class="p-button-text p-button-sm"
              (click)="clearFilters()"
              [pTooltip]="'TASKS.UI.FILTERS.CLEAR' | translate"
            ></button>
            <button
              pButton
              type="button"
              icon="fas fa-download"
              class="p-button-outlined p-button-success p-button-sm"
              (click)="exportToCSV()"
              [pTooltip]="'TASKS.UI.EXPORT.CSV' | translate"
            ></button>
          </div>
        </div>

        @if (!isAdmin) {
          <div class="filters-bar__role-hint">
            <i class="fas fa-info-circle"></i>
            {{ 'TASKS.UI.HEADER.ROLE_HINT' | translate }}
          </div>
        }

        @if (showStats) {
          <section class="vc-tasks-real__stats">
            <div [pTooltip]="'TASKS.UI.STATS.TOTAL_TOOLTIP' | translate">
              <app-kpi-card
                [title]="'TASKS.UI.STATS.TOTAL' | translate"
                [value]="stats.total"
                format="number"
                icon="pi-list"
                iconColor="primary"
                [compact]="true"
              />
            </div>
            <div [pTooltip]="'TASKS.UI.STATS.OVERDUE_TOOLTIP' | translate">
              <app-kpi-card
                [title]="'TASKS.UI.STATS.OVERDUE' | translate"
                [value]="stats.overdue"
                format="number"
                icon="pi-exclamation-triangle"
                iconColor="danger"
                [compact]="true"
              />
            </div>
            <div [pTooltip]="'TASKS.UI.STATS.PENDING_TOOLTIP' | translate">
              <app-kpi-card
                [title]="'TASKS.UI.STATS.PENDING' | translate"
                [value]="stats.pending"
                format="number"
                icon="pi-clock"
                iconColor="warning"
                [compact]="true"
              />
            </div>
            <div [pTooltip]="'TASKS.UI.STATS.IN_PROGRESS_TOOLTIP' | translate">
              <app-kpi-card
                [title]="'TASKS.UI.STATS.IN_PROGRESS' | translate"
                [value]="stats.inProgress"
                format="number"
                icon="pi-spin pi-spinner"
                iconColor="info"
                [compact]="true"
              />
            </div>
            <div [pTooltip]="'TASKS.UI.STATS.COMPLETED_TOOLTIP' | translate">
              <app-kpi-card
                [title]="'TASKS.UI.STATS.COMPLETED' | translate"
                [value]="stats.completed"
                format="number"
                icon="pi-check-circle"
                iconColor="success"
                [compact]="true"
              />
            </div>
            <div>
              <app-kpi-card
                [title]="'TASKS.STATUS.CANCELLED' | translate"
                [value]="stats.cancelled"
                format="number"
                icon="pi-ban"
                iconColor="warning"
                [compact]="true"
              />
            </div>
          </section>
        }

        <!-- Filtros avanzados -->
        @if (showAdvancedFilters) {
          <div class="filters-bar__advanced">
            <div class="filters-bar__row">
              <!-- Estado -->
              <div class="filters-bar__field">
                <label>{{ 'TASKS.UI.FILTERS.STATUS' | translate }}</label>
                <p-multiSelect
                  [options]="statusOptions"
                  [(ngModel)]="selectedStatuses"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="{{ 'TASKS.UI.FILTERS.ALL' | translate }}"
                  (onChange)="applyFilters()"
                  [showClear]="true"
                  styleClass="filters-bar__multiselect"
                ></p-multiSelect>
              </div>

              <!-- Prioridad -->
              <div class="filters-bar__field">
                <label>{{ 'TASKS.UI.FILTERS.PRIORITY' | translate }}</label>
                <p-multiSelect
                  [options]="priorityOptions"
                  [(ngModel)]="selectedPriorities"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="{{ 'TASKS.UI.FILTERS.ALL_FEM' | translate }}"
                  (onChange)="applyFilters()"
                  [showClear]="true"
                  styleClass="filters-bar__multiselect"
                ></p-multiSelect>
              </div>

              <!-- Asignado a -->
              <div class="filters-bar__field">
                <label>{{ 'TASKS.UI.FILTERS.ASSIGNED' | translate }}</label>
                <p-dropdown
                  [options]="userOptions"
                  [(ngModel)]="selectedAssignee"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="{{ 'TASKS.UI.FILTERS.ALL' | translate }}"
                  (onChange)="applyFilters()"
                  [showClear]="true"
                  [filter]="true"
                  filterBy="label"
                  styleClass="filters-bar__dropdown"
                ></p-dropdown>
              </div>

              <!-- Creado por -->
              <div class="filters-bar__field">
                <label>{{ 'TASKS.UI.FILTERS.CREATED_BY' | translate }}</label>
                <p-dropdown
                  [options]="userOptions"
                  [(ngModel)]="selectedCreator"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="{{ 'TASKS.UI.FILTERS.ALL' | translate }}"
                  (onChange)="applyFilters()"
                  [showClear]="true"
                  [filter]="true"
                  filterBy="label"
                  styleClass="filters-bar__dropdown"
                ></p-dropdown>
              </div>

              <!-- Fecha desde -->
              <div class="filters-bar__field">
                <label>{{ 'TASKS.UI.FILTERS.DUE_FROM' | translate }}</label>
                <p-calendar
                  [(ngModel)]="dueDateFrom"
                  dateFormat="dd/mm/yy"
                  placeholder="{{ 'TASKS.UI.FILTERS.FROM' | translate }}"
                  (onSelect)="applyFilters()"
                  (onClear)="applyFilters()"
                  [showClear]="true"
                  styleClass="filters-bar__calendar"
                ></p-calendar>
              </div>

              <!-- Fecha hasta -->
              <div class="filters-bar__field">
                <label>{{ 'TASKS.UI.FILTERS.DUE_TO' | translate }}</label>
                <p-calendar
                  [(ngModel)]="dueDateTo"
                  dateFormat="dd/mm/yy"
                  placeholder="{{ 'TASKS.UI.FILTERS.TO' | translate }}"
                  (onSelect)="applyFilters()"
                  (onClear)="applyFilters()"
                  [showClear]="true"
                  styleClass="filters-bar__calendar"
                ></p-calendar>
              </div>

              <!-- Solo vencidas -->
              <div class="filters-bar__field filters-bar__field--checkbox">
                <p-checkbox
                  [(ngModel)]="showOnlyOverdue"
                  [binary]="true"
                  inputId="showOnlyOverdue"
                  (onChange)="applyFilters()"
                ></p-checkbox>
                <label for="showOnlyOverdue">{{ 'TASKS.UI.FILTERS.ONLY_OVERDUE' | translate }}</label>
              </div>
            </div>
          </div>
        }

        <!-- Contador de resultados -->
        <div class="filters-bar__results">
          <span>
            {{ 'TASKS.UI.RESULTS' | translate:{
              count: flatTasksForTable.length,
              groups: taskGroups.length
            } }}
          </span>
        </div>
      </div>

      <!-- Tabla de tareas con subtareas agrupadas -->
      @if (flatTasksForTable.length === 0) {
        <div class="empty-state">
          <i class="fas fa-clipboard-check"></i>
          <h3>{{ 'TASKS.UI.EMPTY.TITLE' | translate }}</h3>
          <p>{{ 'TASKS.UI.EMPTY.SUBTITLE' | translate }}</p>
          <button
            *ngIf="hasActiveFilters()"
            pButton
            type="button"
            [label]="'TASKS.UI.FILTERS.CLEAR' | translate"
            icon="fas fa-times"
            class="p-button-outlined"
            (click)="clearFilters()"
          ></button>
        </div>
      } @else {
        <div class="tasks-table-container">
          <p-table
            #tasksTable
            [value]="flatTasksForTable"
            [paginator]="true"
            [rows]="50"
            [rowsPerPageOptions]="[25, 50, 100]"
            [showCurrentPageReport]="true"
            currentPageReportTemplate="{{ 'TASKS.UI.TABLE.PAGE_REPORT' | translate }}"
            styleClass="p-datatable-sm tasks-table"
            [rowHover]="true"
            [scrollable]="true"
            scrollHeight="calc(100vh - 400px)"
          >
            <ng-template pTemplate="header">
              <tr>
                <th class="tasks-table__col tasks-table__col--expand"></th>
                <th class="tasks-table__col tasks-table__col--key">{{ 'TASKS.UI.TABLE.KEY' | translate }}</th>
                <th class="tasks-table__col tasks-table__col--title">{{ 'TASKS.UI.TABLE.TITLE' | translate }}</th>
                <th class="tasks-table__col tasks-table__col--priority">{{ 'TASKS.UI.TABLE.PRIORITY' | translate }}</th>
                <th class="tasks-table__col tasks-table__col--status">{{ 'TASKS.UI.TABLE.STATUS' | translate }}</th>
                <th class="tasks-table__col tasks-table__col--date">{{ 'TASKS.DETAIL.DUE_DATE_LABEL' | translate }}</th>
                <th class="tasks-table__col tasks-table__col--assigned">{{ 'TASKS.UI.TABLE.ASSIGNED' | translate }}</th>
                <th class="tasks-table__col tasks-table__col--actions">{{ 'TASKS.UI.TABLE.ACTIONS' | translate }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-row>
              <tr
                [class.task-row--subtask]="row.isSubtask"
                [class.task-row--overdue]="isOverdue(row.task)"
                [class.task-row--due-soon]="isDueSoon(row.task)"
                [class.task-row--completed]="row.task.status === 'completed'"
              >
                <!-- Expand / Completar -->
                <td class="task-expand-cell">
                  @if (!row.isSubtask && hasSubtasks(row.task.id)) {
                    <button
                      pButton
                      type="button"
                      [icon]="isGroupExpanded(row.task.id) ? 'fas fa-chevron-down' : 'fas fa-chevron-right'"
                      class="p-button-text p-button-sm expand-btn"
                      (click)="toggleSubtasks(row.task.id)"
                      [pTooltip]="isGroupExpanded(row.task.id)
                        ? ('TASKS.UI.SUBTASKS.HIDE' | translate)
                        : ('TASKS.UI.SUBTASKS.SHOW' | translate:{ count: getSubtasksCount(row.task.id) })"
                    ></button>
                  } @else if (!row.isSubtask) {
                    <button
                      pButton
                      type="button"
                      [icon]="row.task.status === 'completed' ? 'fas fa-check-circle' : 'far fa-circle'"
                      [class]="row.task.status === 'completed' ? 'p-button-success p-button-text p-button-sm' : 'p-button-secondary p-button-text p-button-sm'"
                      (click)="toggleComplete(row.task)"
                      [disabled]="!canChangeTaskStatus(row.task)"
                      [pTooltip]="canChangeTaskStatus(row.task)
                        ? (row.task.status === 'completed'
                          ? ('TASKS.UI.STATUS.REOPEN' | translate)
                          : ('TASKS.UI.STATUS.COMPLETE' | translate))
                        : ('TASKS.UI.STATUS.NO_PERMISSION' | translate)"
                    ></button>
                  } @else {
                    <span class="subtask-indent">
                      <i class="fas fa-level-up-alt fa-rotate-90"></i>
                    </span>
                  }
                </td>

                <!-- Task Key -->
                <td class="task-key-cell">
                  <span class="task-key" [class.task-key--subtask]="row.isSubtask" (click)="viewTask(row.task)">
                    {{ row.task.task_key }}
                  </span>
                </td>

                <!-- Título -->
                <td class="task-title-cell">
                  <div class="task-title-wrapper" [class.task-title-wrapper--subtask]="row.isSubtask">
                    <a class="task-title-link" (click)="viewTask(row.task)">
                      {{ row.task.title }}
                    </a>
                    <!-- Indicadores -->
                    <div class="task-indicators">
                      @if (!row.isSubtask && hasSubtasks(row.task.id)) {
                        <span class="indicator indicator--subtasks" [pTooltip]="('TASKS.UI.SUBTASKS.COUNT' | translate:{ count: getSubtasksCount(row.task.id) })">
                          <i class="fas fa-sitemap"></i>
                          {{ getSubtasksCount(row.task.id) }}
                        </span>
                      }
                      @if (row.task.patients && row.task.patients.length > 0) {
                        <span class="indicator indicator--patients" [pTooltip]="getPatientsNames(row.task)">
                          <i class="fas fa-user-injured"></i>
                          {{ row.task.patients.length }}
                        </span>
                      }
                      @if (row.task.appointments && row.task.appointments.length > 0) {
                        <span class="indicator indicator--appointments" [pTooltip]="('TASKS.UI.APPOINTMENTS.COUNT' | translate:{ count: row.task.appointments.length })">
                          <i class="fas fa-calendar-check"></i>
                          {{ row.task.appointments.length }}
                        </span>
                      }
                    </div>
                  </div>
                </td>

                <!-- Prioridad -->
                <td>
                  <p-tag
                    [value]="getPriorityLabel(row.task.priority)"
                    [severity]="getPrioritySeverity(row.task.priority)"
                    [rounded]="true"
                  ></p-tag>
                </td>

                <!-- Estado -->
                <td>
                  <p-tag
                    [value]="getStatusLabel(row.task.status)"
                    [severity]="getStatusSeverity(row.task.status)"
                  ></p-tag>
                </td>

                <!-- Fecha vencimiento -->
                <td class="task-date-cell">
                  <div
                    class="task-date-wrapper"
                    [class.task-date--overdue]="isOverdue(row.task)"
                    [class.task-date--due-soon]="isDueSoon(row.task)"
                  >
                    <span>{{ formatDate(row.task.due_date) }}</span>
                    @if (isOverdue(row.task)) {
                      <span class="task-date-badge task-date-badge--overdue">!</span>
                    }
                    @if (isDueSoon(row.task)) {
                      <span class="task-date-badge task-date-badge--soon">
                        <i class="fas fa-clock"></i>
                      </span>
                    }
                  </div>
                </td>

                <!-- Asignado a -->
                <td>
                  <div class="task-assignees">
                    @if (row.task.assignees && row.task.assignees.length > 0) {
                      <div class="assignee-avatars">
                        @for (assignee of row.task.assignees.slice(0, 3); track assignee.id) {
                          <span 
                            class="assignee-avatar" 
                            [pTooltip]="assignee.name + ' ' + (assignee.surname || '')"
                          >
                            {{ getUserShortLabel(assignee) }}
                          </span>
                        }
                        @if (row.task.assignees.length > 3) {
                          <span class="assignee-more">+{{ row.task.assignees.length - 3 }}</span>
                        }
                      </div>
                    } @else if (row.task.assignee) {
                      <div class="task-user">
                        <div class="task-user__avatar">
                          {{ getUserShortLabel(row.task.assignee) }}
                        </div>
                        <span class="task-user__name">{{ getAssigneeName(row.task) }}</span>
                      </div>
                    } @else {
                      <span class="task-user__empty">{{ 'TASKS.UI.ASSIGNEE.NONE' | translate }}</span>
                    }
                  </div>
                </td>

                <!-- Acciones -->
                <td class="task-actions-cell">
                  <div class="task-actions">
                    <button
                      pButton
                      type="button"
                      icon="fas fa-eye"
                      class="p-button-info p-button-text p-button-sm"
                      (click)="viewTask(row.task)"
                      [pTooltip]="'TASKS.UI.ACTIONS.VIEW' | translate"
                    ></button>
                    @if (canEditTask(row.task)) {
                      <button
                        pButton
                        type="button"
                        icon="fas fa-edit"
                        class="p-button-warning p-button-text p-button-sm"
                        (click)="editTask(row.task)"
                        [pTooltip]="'TASKS.UI.ACTIONS.EDIT' | translate"
                      ></button>
                      <button
                        pButton
                        type="button"
                        icon="fas fa-trash"
                        class="p-button-danger p-button-text p-button-sm"
                        (click)="deleteTask(row.task)"
                        [pTooltip]="'TASKS.UI.ACTIONS.DELETE' | translate"
                      ></button>
                    }
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="8" class="text-center p-4">
                  {{ 'TASKS.UI.EMPTY.TABLE' | translate }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      }
    </div>
  }
  </main>

  <!-- Modal crear/editar tarea -->
</div>
